import AcHtmlElement from "./html-element";
export var insertAfter = function (newNode, referenceNode) {
    var _a;
    (_a = referenceNode === null || referenceNode === void 0 ? void 0 : referenceNode.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(newNode, referenceNode.nextSibling);
};
export var insertBefore = function (newNode, referenceNode) {
    var _a;
    (_a = referenceNode === null || referenceNode === void 0 ? void 0 : referenceNode.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(newNode, referenceNode);
};
export var createElementFromString = function (content, baseElement) {
    if (baseElement === void 0) { baseElement = 'div'; }
    return AcHtmlElement.create(baseElement).addHtml(content).getElement();
};
